import React, { useState } from "react";
import { Formheader, GrayBox } from "@/Components";
import TwoFactorDialogCenter from "@/Pages/Account/partials/TwoFactorDialogCenter";
import axios from "axios";
import { Inertia } from "@inertiajs/inertia";

function TwoFactorSettings({ user }) {
  const [showEnableModal, setShowEnableModal] = useState(false);
  const [showDisableModal, setShowDisableModal] = useState(false);

  return (
    <>
      <GrayBox>
        <div className="flex flex-col gap-4">
          <Formheader margin="w-full">Two factor authenticator</Formheader>
          <p>
            Two-factor authentication adds an extra layer of security to your
            account. Once enabled, you'll need to provide a code from your phone
            in addition to your password. You will be required to verify your
            password first.
          </p>

          <div>
            {user?.is_two_factor_enabled ? (
              <button
                className="btn-blue"
                onClick={() => setShowDisableModal(true)}
              >
                Disable
              </button>
            ) : (
              <button
                className="btn-blue"
                onClick={() => {
                  Inertia.post("/user/two-factor-authentication", null, {
                    onSuccess: () => {
                      setShowEnableModal(true);
                    },
                  });
                }}
              >
                Enable
              </button>
            )}
          </div>
        </div>
      </GrayBox>
      <TwoFactorDialogCenter
        showEnableModal={showEnableModal}
        setShowEnableModal={setShowEnableModal}
        showDisableModal={showDisableModal}
        setShowDisableModal={setShowDisableModal}
      />
    </>
  );
}

export default TwoFactorSettings;
